import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoMultipleChoice16 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M3.2666 9.26965C4.44927 9.26971 5.4082 10.2285 5.4082 11.4113C5.40795 12.5938 4.44911 13.5528 3.2666 13.5529C2.08409 13.5528 1.12525 12.5938 1.125 11.4113C1.125 10.2285 2.08393 9.2697 3.2666 9.26965ZM3.2666 10.5197C2.77428 10.5197 2.375 10.9189 2.375 11.4113C2.37525 11.9034 2.77443 12.3028 3.2666 12.3029C3.75877 12.3028 4.15795 11.9034 4.1582 11.4113C4.1582 10.9189 3.75892 10.5197 3.2666 10.5197ZM14.2617 10.7863C14.6068 10.7864 14.8867 11.0661 14.8867 11.4113C14.8865 11.7562 14.6067 12.0362 14.2617 12.0363H7.81641C7.47151 12.0361 7.19164 11.7561 7.19141 11.4113C7.19141 11.0662 7.47136 10.7864 7.81641 10.7863H14.2617ZM5.03906 2.69836C5.24453 2.42104 5.63573 2.36303 5.91309 2.56848C6.19029 2.77392 6.24921 3.16519 6.04395 3.4425L3.51562 6.85461C3.4108 6.99586 3.2512 7.08701 3.07617 7.10461C2.90117 7.12214 2.7265 7.06496 2.5957 6.94739L1.33203 5.80969C1.07555 5.57886 1.0545 5.18346 1.28516 4.92688C1.51607 4.67031 1.9114 4.65007 2.16797 4.88098L2.91992 5.55774L5.03906 2.69836ZM14.2617 4.34094C14.6068 4.34104 14.8867 4.62083 14.8867 4.96594C14.8865 5.31091 14.6067 5.59084 14.2617 5.59094H7.81641C7.47147 5.59079 7.19158 5.31088 7.19141 4.96594C7.19141 4.62086 7.47136 4.3411 7.81641 4.34094H14.2617Z" fill={iconColor} />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoMultipleChoice16;